import React from 'react';

/**
 * Subtle section divider component
 * Creates visual separation without jarring transitions
 * Based on 2025 fintech UI best practices
 */
const SectionDivider = ({ variant = 'gradient', className = '' }) => {
  const variants = {
    // Subtle gradient fade
    gradient: (
      <div className={`w-full h-px bg-gradient-to-r from-transparent via-border to-transparent ${className}`} />
    ),
    // Glowing line
    glow: (
      <div className={`w-full h-px relative ${className}`}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent blur-sm" />
      </div>
    ),
    // Dotted pattern
    dots: (
      <div className={`w-full flex justify-center gap-2 py-4 ${className}`}>
        <div className="w-1.5 h-1.5 rounded-full bg-border" />
        <div className="w-1.5 h-1.5 rounded-full bg-border" />
        <div className="w-1.5 h-1.5 rounded-full bg-border" />
      </div>
    ),
    // Wide gradient band (for stronger separation)
    band: (
      <div className={`w-full h-16 bg-gradient-to-b from-transparent via-card/30 to-transparent ${className}`} />
    ),
    // Minimal space only
    space: (
      <div className={`w-full h-8 ${className}`} />
    ),
  };

  return variants[variant] || variants.gradient;
};

export default SectionDivider;
